import React from 'react'

const About = () => {
  return (
    <section className="about container" id="features">
        <div className="img">
          <img src="first-meal.jpg" alt="meal" />
        </div>
        <div className="content">
          <p className="title">
            We pride ourselves on making real food from the best ingredients.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam et
            purus a odio finibus bibendum in sit amet leo. Mauris feugiat erat
            tellus.
          </p>
          <button>Learn More</button>
        </div>
      </section>
  )
}

export default About